/* eslint-disable react-hooks/exhaustive-deps */
import {
    Button,
    CircularProgress,
    createStyles,
    Grid,
    makeStyles,
    Theme,
    Typography,
} from "@material-ui/core";
import React, { useContext } from "react";
import { UserContext } from "../../contexts/AppContext";
import { useHistory } from "react-router";
import { StepFour } from "./components/FormSteps/StepFour";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import announcePic from "../../images/announcePic.png";
import {
    addressDefaultValue,
    announceInputsDefaultValue,
    locationDefaultValue,
    propertyInputsDefaultValue,
    propertyTypeInputsDefaultValue,
    propertyTypesDefaultValue,
} from "../../utils/defaultNullValues";
import {
    AnnounceInputs,
    IAddress,
    ILocation,
    IPropertyType,
    IPropertyTypeInputs,
    PropertyInputs,
} from "../../utils/AnnounceInterfaces";
import SessionHandler from "../../https/SessionHandler";
import { PropertyService } from "./services/PropertyService";
import { Error } from "@material-ui/icons";
import { colors } from "../../styles/defaultColors";
import {
    EAnnounceErrorMessages,
    EPropertyErrorMessages,
} from "../../utils/enum/properties";
import { useTranslation } from "react-i18next";
import { StepFive } from "./components/FormSteps/StepFive";
// import {CountryService} from "../Admin/Countries/services/EquipmentCountry";
import { EAnnounceStatus } from "../../utils/enum";
import { HotelService } from "../Admin/Hotel/services/hotelService";
// import {IHotel} from "../../utils/HotelInterface";
import { EPaymentMethod } from "../../utils/enum/PaymentMethod";
import { IPaymentMethodSelectProps } from "../../utils/PaymentInterfaces";
import { StepSeven } from "./components/FormSteps/StepSeven";
import { ChoiceHotel } from "./components/ChoiceHotel";
import { DetailChambre } from "./components/FormSteps/DetaiChambre";
import { CountryPhoneList } from "../../utils/CountryList";
import moment from "moment";
import { StepSix } from "./components/FormSteps/StepSix";
import { StepEight } from "./components/FormSteps/StepEight";
import Spin from "../../images/Spin";
import { useParams } from "react-router-dom";
import MessageBrouillon from "../components/MessageBrouillon";
const styles = makeStyles((theme: Theme) =>
    createStyles({
        properties: {
            width: "100%",
            textAlign: "center",
            [theme.breakpoints.down("sm")]: {
                minHeight: 1200,
            },
            marginBottom: 120,
        },
        propertiesHeader: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        propertiesTitle: {
            fontSize: 22,
            fontFamily: "Josefin Sans !important",
            color: "#890608",
            marginTop: "40px !important",
        },
        propertiesStepper: {
            width: "40%",
            marginBottom: 30,
            [theme.breakpoints.down("sm")]: {
                width: "70%",
            },
            "&.MuiPaper-root": {
                background: "none",
            },
        },
        propertiesCheck: {},
        propertiesCheckbox: {
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        showErrors: {},
        checkboxLabel: {
            "&:not(:last-child)": {
                marginBottom: 20,
            },
            "& span": {
                fontFamily: "Josefin Sans",
                color: "#5F5F5F",
            },
        },
        checkboxLegend: {
            textAlign: "left",
            fontSize: 18,
            fontFamily: "Josefin Sans",
            color: "#000000",
            marginBottom: 30,
        },
        checkboxGroup: {},
        propertiesBtn: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: 50,
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        Button: {
            fontFamily: "Josefin Sans",
            color: "#890608",
            textTransform: "capitalize",
        },
        ButtonPrevious: {
            textTransform: "capitalize",
            color: "#000000",
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
        "@global": {
            ".MuiStepIcon-root.MuiStepIcon-active, .MuiStepIcon-root.MuiStepIcon-completed":
                {
                    color: "#890608",
                },
            ".MuiOutlinedInput-input": {
                padding: "9px 14px",
            },
        },
    })
);

function getSteps() {
    return [
        "Select campaign settings",
        "Create an ad",
        "Set geolocation",
        "Add photos",
        "Add test",
        "Add payment reference",
        "Contact informations",
    ];
}

// const countryService = new CountryService();
const propertyService = new PropertyService();
const hotelService = new HotelService();

export function AddAnnounceHotel() {
    const classes = styles();
    const sessionHandler = React.useMemo(() => new SessionHandler(), []);
    const SearchTypeName= 'htls';
    const isConnected = sessionHandler.isConnected;
    const userContext = useContext(UserContext);
    const { user, setUser } = userContext;
    const history = useHistory();
    const [activeStep, setActiveStep] = React.useState<number>(0);
    const [skipped, setSkipped] = React.useState(new Set<number>());
    const steps = getSteps();
    const [address, setAddress] = React.useState<IAddress>(addressDefaultValue);
    const [propertyType, setPropertyType] = React.useState<IPropertyTypeInputs>(
        propertyTypeInputsDefaultValue
    );
    const [equipments, setEquipments] = React.useState<Array<string>>([]);
    const [equipmentsSelected, setEquipmentsSelected] = React.useState<any>([]);
    // const [paymentModeSelected, setPayementModeSelected] = React.useState<any>([]);
    const [property, setProperty] = React.useState<PropertyInputs>(
        propertyInputsDefaultValue
    );
    const [propertyTypeList, setPropertyTypeList] = React.useState<
        IPropertyType[]
    >(propertyTypesDefaultValue);

    const [announce, setAnnounce] = React.useState<AnnounceInputs>({
        ...announceInputsDefaultValue,
        state: EAnnounceStatus.Submitted,
        owner: user._id,
    });

    const [loading, setLoading] = React.useState(true);
    const [isSaving, setIsSaving] = React.useState(false);
    let errors: string[] = [];
    const [errorMessages, setErrorMessages] = React.useState<string>("");
    const [location, setLocation] =
        React.useState<ILocation>(locationDefaultValue);
    const { t } = useTranslation();
    const [hoteSelected, setHotelSelected] = React.useState<any>([]);
    const [hotel, setHotel] = React.useState<string>("");
    const [reglement, setReglement] = React.useState<string>("");
    const [choixHotel, setChoix] = React.useState<string>("");
    const [hotelList, setHotelList] = React.useState<any>([]);
    const [typeSelected, setTypeSelected] = React.useState<any>([]);
    const [,] = React.useState<IPaymentMethodSelectProps[]>([]);
    const [payment] = React.useState([]);
    const [typeChambre, setType] = React.useState<string>("");
    const [type, setTypeHotel] = React.useState<string>("");
    const [checkedAnimaux, setCheckedAnimaux] = React.useState<any>(false);
    const [checkedEnfant, setCheckedEnfant] = React.useState<any>(false);
    const [checkedFetes, setCheckedFetes] = React.useState<any>(false);
    const [jardin, setCheckedJardin] = React.useState<any>(false);
    const [devise, setDevise] = React.useState("");
    const [checkin, setDispatchTime] = React.useState(moment());
    const [checkout, setDispatchTimeOut] = React.useState(moment());
    const [paypalAccount, setPaypalAccount] = React.useState<string[]>([]);
    const [orangeAccount, setOrangeAccount] = React.useState<string[]>([]);
    const [mtnAccount, setMtnAccount] = React.useState<string[]>([]);
    const [expressUnionAccount, setExpressUnionAccount] = React.useState<
        string[]
    >([]);
    const [codePhone, setCodePhone] = React.useState("");
    const [paymentSelected] = React.useState<any>([]);
    const [acceptConditions, setAcceptConditions] =
        React.useState<boolean>(false);
    const [priceWeeklyDaily, setPriceWeeklyDaily] = React.useState<number>(0);
    const [priceBiWeeklyDaily, setPriceBiWeeklyDaily] =
        React.useState<number>(0);
    const [priceMonthlyDaily, setPriceMonthlyDaily] = React.useState<number>(0);
    const [newPhotos, setNewPhotos] = React.useState<any>([]);
    const [draftedId, setDraftedId] = React.useState<string | null>(null);
    const [typeLogement, setTypeLogement] = React.useState<string>("");
    const [draftedAnnounceId, setDraftedAnnounceId] = React.useState<
        string | null
    >(null);

    enum Ebutton {
        Next = "next",
        Archive = "archive",
    }

    const params: { id: string } = useParams();

    const handleAcceptConditions = () => {
        setAcceptConditions(!acceptConditions);
    };

    const handleValueChange = (value: any) => {
        setDispatchTime(value);
    };

    const handleValueChangeOut = (value: any) => {
        setDispatchTimeOut(value);
    };


    const [valueGroup, setValueGroup] = React.useState('female');

    const handleChangeGroup = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValueGroup((event.target as HTMLInputElement).value);
        setAnnounce({
            ...announce,
            remboursable:(event.target as HTMLInputElement).value
        })
    };

    const reglementToSelect = [
        {
            id: "1",
            name: "fumeur",
            label: t("annonce.labels.fumeur"),
        },
        {
            id: "2",
            name: "non fumeur",
            label: t("annonce.labels.non-fumeur"),
        },
    ];
    const type_de_chambre = [
        {
            id: "1",
            name: "Simple",
            label: "annonce.labels.simple",
        },
        {
            id: "2",
            name: "Double",
            label: "annonce.labels.double",
        },
        {
            id: "3",
            name: "Lits Jumeaux",
            label: "annonce.labels.lits-jumeaux",
        },
        {
            id: "4",
            name: "Lits Double",
            label: "annonce.labels.lit-double",
        },
        {
            id: "5",
            name: "Triple",
            label: "annonce.labels.triple",
        },
        {
            id: "6",
            name: "Quadruple",
            label: "annonce.labels.quadruple",
        },
        {
            id: "7",
            name: "Familiale",
            label: "annonce.labels.familiale",
        },
        {
            id: "8",
            name: "Suite",
            label: "annonce.labels.suite",
        },
        {
            id: "9",
            name: "Appartement",
            label: "annonce.labels.appartement",
        },
        {
            id: "10",
            name: "Dortoir",
            label: "annonce.labels.dortoir",
        },
        {
            id: "7",
            name: "Lit en dortoir",
            label: "annonce.labels.lits-en-dortoir",
        },
    ];


    React.useEffect(() => {
        if (!user.email) {
            isConnected()
                .then((response: any) => {
                    if (response.success) {
                        setUser(response.data);
                        setAnnounce({
                            ...announce,
                            owner: response.data._id,
                        });
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    history.push("/");
                });
        } else {
            setLoading(true);
            propertyService
                .getAllPropertyTypes()
                .then((response) => {
                    if (response.success) {
                        setPropertyTypeList(response.data);
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                });
        }
    }, [user, history, isConnected, setUser]);

    React.useEffect(() => {
        if (params.id) {
            propertyService.getAnnounceByIdAdm(params.id).then((response) => {
                setDraftedAnnounceId(params.id);
                const dataProperty = {
                    ...response.data.property,
                    hotel: response.data?.property?.hotel?._id,
                };
                //console.log(response.data.activeStep)

                setProperty(dataProperty);
                setPropertyType(response.data.property.type)
                setHotel(response.data.property.hotel._id);
                setAnnounce(response.data);
                setPaypalAccount(response.data.account_paypal);
                setActiveStep(response.data.activeStep);
                const propertyType = type_de_chambre.find(
                    (item) => item.name === response.data.property.typeChambre
                );
                if (propertyType) setTypeSelected(propertyType);
                const reglementSelected = reglementToSelect.find(
                    (item) => item.name === response.data.property.reglement
                );
                if (reglementSelected) setHotelSelected(reglementSelected);
                let checkedEquipments: string[] = [];
                response.data.property.equipments.forEach((item: any) =>
                    checkedEquipments.push(item._id)
                );
                setAddress(response.data.property.address);
                setEquipments(checkedEquipments);
                setLocation({
                    latitude: response.data.property.location.latitude,
                    longitude: response.data.property.location.longitude,
                });
                setCheckedAnimaux(response.data.animaux);
                setCheckedEnfant(response.data.enfant);
                setCheckedFetes(response.data.fetes);
                setDispatchTime(moment(response.data.checkin));
                setDispatchTimeOut(moment(response.data.checkout));
                setPriceWeeklyDaily(Number(response.data.priceWeekly / 7));
                setPriceBiWeeklyDaily(Number(response.data.priceBiWeekly / 14));
                setPriceMonthlyDaily(Number(response.data.priceMonthly / 30));
            });
        }
    }, [params.id, propertyTypeList, draftedAnnounceId]);

    const isStepSkipped = (step: number) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        typeLogement === undefined || typeLogement === ""
            ? setTypeHotel(
                  propertyTypeList.filter((val: any) => val.name === "Hôtel")[0]
                      ._id
              )
            : setTypeHotel(
                  propertyTypeList.filter(
                      (val: any) => val.name === typeLogement
                  )[0]._id
              );
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        let showNextStep = true;
        if (activeStep === 0) {
            showNextStep = isHotelValidate(hotel);
        } else if (activeStep === 1) {
            showNextStep = TypeHotelErrorMessages(property, propertyType);
        } else if (activeStep === 2) {
            showNextStep = isPhotosValidate(property);
        } else if (activeStep === 3) {
            showNextStep = isAnnounceValidate(announce);
        } else if (activeStep === 4) {
            showNextStep = isAnnounceStepSix(announce, property);
        }

        if (showNextStep) {
            errors = [];
            setErrorMessages("");
            handleArchive(Ebutton.Next);
            if (!params.id && draftedAnnounceId){
                setLoading(true)
                setTimeout(() => {
                    history.push(`add/${draftedAnnounceId}`)
                    setLoading(false)
                }, 1000);
            }
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
        } else {
            showErrorsMessages();
        }
    };

    const handleBack = () => {
        if (activeStep === 1) {
            setHotel("");
        }
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const onChangeHandler = (event: any): void => {
        setProperty({ ...property, [event.target.name]: event.target.value });
    };

    const handleOnChangeSelect = (key: string, v: string) => {
        setAnnounce({ ...announce, [key]: v });
    };

    const onChangePropertyType = (value: any): void => {
        setTypeSelected(value);

        if (value != null) {
            setChoix(value.name);
            setType(value.name);
        }
    };

    React.useEffect(() => {
        setProperty({
            ...property,
            owner: user._id,
            typeChambre,
        });
    }, [typeChambre]);

    React.useEffect(() => {
        setProperty({
            ...property,
            owner: user._id,
            type,
        });
    }, [type]);

    let tabPaypal: any = [];
    let tabMobile: any = [];
    for (let i in payment) {
        if (payment[i] === EPaymentMethod.Paypal) {
            if (user.payments.paypal.length !== 0) {
                user.payments.paypal.map((paypl) => {
                    return tabPaypal.push({
                        payement: "Paypal",
                        label:
                            paypl.recepient_email ||
                            paypl.recepient_paypal_id ||
                            paypl.recepient_phone,
                        value: paypl._id || "",
                    });
                });
            }
        } else if (payment[i] === EPaymentMethod.Orange) {
            if (user.payments.mobileMoney.length !== 0) {
                user.payments.mobileMoney.forEach((mm) => {
                    tabMobile.push({
                        payement: "Orange",
                        label: mm.mobile_number,
                        value: mm._id || " ",
                    });
                });
            }
        } else if (payment[i] === EPaymentMethod.MTN) {
            if (user.payments.mobileMoney.length !== 0) {
                user.payments.mobileMoney.forEach((mm) => {
                    tabMobile.push({
                        payement: "MTN",
                        label: mm.mobile_number,
                        value: mm._id || " ",
                    });
                });
            }
        } else if (payment[i] === EPaymentMethod.Nexttel) {
            if (user.payments.mobileMoney.length !== 0) {
                user.payments.mobileMoney.forEach((mm) => {
                    tabMobile.push({
                        payement: "Nexttel",
                        label: mm.mobile_number,
                        value: mm._id || " ",
                    });
                });
            }
        } else if (payment[i] === EPaymentMethod.ExpressUnion) {
            if (user.payments.mobileMoney.length !== 0) {
                user.payments.mobileMoney.forEach((mm) => {
                    tabMobile.push({
                        payement: "ExpressUnion",
                        label: mm.mobile_number,
                        value: mm._id || " ",
                    });
                });
            }
        } else if (payment[i] === EPaymentMethod.YUP) {
            if (user.payments.mobileMoney.length !== 0) {
                user.payments.mobileMoney.forEach((mm) => {
                    tabMobile.push({
                        payement: "YUP",
                        label: mm.mobile_number,
                        value: mm._id || " ",
                    });
                });
            }
        }
    }
    const onChangePaymentMethod = (values: any): void => {
        setAnnounce({
            ...announce,
        });
    };

    const onChangeAnnounce = (event: any): void => {
        setAnnounce({ ...announce, [event.target.name]: event.target.value });
    };

    const onChangeSpecialPriceAnnounce = (event: any): void => {
        switch (event.target.name) {
            case "priceWeeklyDaily": {
                setPriceWeeklyDaily(event.target.value);
                setAnnounce({
                    ...announce,
                    priceWeekly: event.target.value * 7,
                });
                break;
            }
            case "priceBiWeeklyDaily": {
                setPriceBiWeeklyDaily(event.target.value);
                setAnnounce({
                    ...announce,
                    priceBiWeekly: event.target.value * 14,
                });
                break;
            }
            case "priceMonthlyDaily": {
                setPriceMonthlyDaily(event.target.value);
                setAnnounce({
                    ...announce,
                    priceMonthly: event.target.value * 30,
                });
                break;
            }
            case "priceWeekly": {
                setAnnounce({ ...announce, priceWeekly: event.target.value });
                setPriceWeeklyDaily(
                    Number(
                        (event.target.value / 7).toFixed(
                            devise?.toUpperCase() === "XAF" ? 0 : 2
                        )
                    )
                );
                break;
            }
            case "priceBiWeekly": {
                setAnnounce({ ...announce, priceBiWeekly: event.target.value });
                setPriceBiWeeklyDaily(
                    Number(
                        (event.target.value / 14).toFixed(
                            devise?.toUpperCase() === "XAF" ? 0 : 2
                        )
                    )
                );
                break;
            }
            case "priceMonthly": {
                setAnnounce({ ...announce, priceMonthly: event.target.value });
                setPriceMonthlyDaily(
                    Number(
                        (event.target.value / 30).toFixed(
                            devise?.toUpperCase() === "XAF" ? 0 : 2
                        )
                    )
                );
                break;
            }
        }
    };

    const onChangeSuperOffer = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAnnounce({ ...announce, superOffer: event.target.checked ? 1 : 0 });
    };

    const onChangeEquipments = (value: any): void => {
        setEquipmentsSelected(value);
        const ids: string[] = value.map((value: any) => value._id);
        setEquipments(ids);
    };
    React.useEffect(() => {
        setProperty({
            ...property,
            equipments,
        });
    }, [equipments]);

    React.useEffect(() => {
        hotelService
            .getHotelByUser(user._id)
            .then((response) => {
                if (response.success) {
                    setHotelList(response.hotel);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [setLoading, setHotelList]);

    const onChangePhoto = (photos: any) => {
        if (params.id) {
            setNewPhotos(photos);
            // setProperty({
            //     ...property,
            //     photos: [...property.photos, newPhotos],
            //     address,
            // });
        } else {
            setNewPhotos(photos);
            // setProperty({
            //     ...property,
            //     photos: [...photos],
            // });
        }
    };
    
    /*React.useEffect(() => {
        setCodePhone(
            CountryPhoneList.filter(
                (devi: any) =>
                    devi.name?.toLowerCase() === address.country?.name?.toLowerCase()
            )[0]?.dial_code
        );
    }, [address]);*/

    const onChangeHotel = (value: any): void => {
        setHotelSelected(value);
        if (value != null) {
            setReglement(value.name);
        }
    };

    React.useEffect(() => {
        setProperty({
            ...property,
            reglement,
        });
    }, [reglement]);

    const onChangeHotelClick = (data: any) => {
        setAddress({
            ...address,
            country: data.address.country?.name,
            city: data.address.city?.name,
            street: data.address.street,
            quartier: data.address.quartier,
        });
        setLocation({
            longitude: data.location.longitude,
            latitude: data.location.latitude,
        });
        setHotel(data._id);
        setTypeLogement(data.typeLogement);
    };
    React.useEffect(() => {
        let propType;
        if (typeLogement) {
            propType = propertyTypeList.filter(
                (val: any) => val.name === typeLogement
            )[0]?._id;
        } else {
            propType = propertyTypeList.filter(
                (val: any) => val.name === "Hôtel"
            )[0]?._id;
        }
        setProperty({
            ...property,
            address,
            location,
            hotel,
            type: propType,
        });
    }, [address, location, hotel, typeLogement]);
   /*
    React.useEffect(() => {
        setDevise(
            CountryPhoneList.filter(
                (devi: any) =>
                    devi.name?.toLowerCase() === address.country?.name?.toLowerCase()
            )[0]?.currencyCode
        );
    }, [address]);

    React.useEffect(() => {
        setCodePhone(
            CountryPhoneList.filter(
                (devi: any) =>
                    devi.name?.toLowerCase() === address.country?.name?.toLowerCase()
            )[0]?.dial_code
        );
    }, [address]);
    */

    /*reglement interne*/
    const handleChangeCheckedAnimaux = (v: any) => {
        setCheckedAnimaux(v);
    };
    const handleChangeCheckedEnfant = (v: any) => {
        setCheckedEnfant(v);
    };
    const handleChangeCheckedFetes = (v: any) => {
        setCheckedFetes(v);
    };
    const handleChangeCheckedJardin = (v: any) => {
        setCheckedJardin(v.target.checked);
    };
    React.useEffect(() => {
        setProperty({
            ...property,
            jardin: jardin,
        });
    }, [jardin]);
    React.useEffect(() => {
        setAnnounce({
            ...announce,
            devise: devise,
            animaux: checkedAnimaux,
            enfant: checkedEnfant,
            fetes: checkedFetes,
            codePhone: codePhone,
        });
    }, [
        devise,
        checkedAnimaux,
        checkedEnfant,
        checkedFetes,
        codePhone,
        address,
    ]);
    React.useEffect(() => {
        setAnnounce({
            ...announce,
            checkin: checkin,
            checkout: checkout,
        });
    }, [checkin, checkout]);

    const actualStepForm = () => {
        switch (activeStep) {
            case 0:
                return (
                    <ChoiceHotel
                        setHotel={setHotel}
                        onClickHotel={onChangeHotelClick}
                    />
                );
            case 1:
                return (
                    <DetailChambre
                        handleChangePropertyType={onChangePropertyType}
                        handleChange={onChangeHandler}
                        onChangeHotel={onChangeHotel}
                        values={property}
                        hotelList={hotelList}
                        hoteSelected={hoteSelected}
                        propertyTypeValues={propertyType}
                        onChangeMultiSelect={onChangeEquipments}
                        propertyTypeList={propertyTypeList}
                        equipmentsSelected={equipmentsSelected}
                        typeSelected={typeSelected}
                        choixHotel={choixHotel}
                        handleChangeCheckedJardin={handleChangeCheckedJardin}
                        setEquipments={setEquipments}
                        equipments={equipments}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 2:
                return (
                    <StepFour
                        handleChangePhotos={onChangePhoto}
                        values={property}
                        propertyId={property._id || draftedId!}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 3:
                return (
                    <StepFive
                        address={address}
                        handleChange={onChangeAnnounce}
                        handleChangeSpecialPrice={onChangeSpecialPriceAnnounce}
                        devise={devise}
                        handleSuperOffer={onChangeSuperOffer}
                        values={announce}
                        propertyTypeValues={propertyType}
                        priceWeeklyDaily={priceWeeklyDaily}
                        priceBiWeeklyDaily={priceBiWeeklyDaily}
                        priceMonthlyDaily={priceMonthlyDaily}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 4:
                return (
                    <StepSix
                        country={address.country?.name}
                        handleChange={onChangeAnnounce}
                        handleOnChange={handleOnChangeSelect}
                        values={announce}
                        handleChangePaymentMethod={onChangePaymentMethod}
                        setPaypalAccount={setPaypalAccount}
                        paypalAccount={paypalAccount}
                        setOrangeAccount={setOrangeAccount}
                        orangeAccount={orangeAccount}
                        setMtnAccount={setMtnAccount}
                        mtnAccount={mtnAccount}
                        setExpressUnionAccount={setExpressUnionAccount}
                        expressUnionAccount={expressUnionAccount}
                        paymentSelected={paymentSelected}
                        codePhone={codePhone}
                        valueGroup={valueGroup}
                        handleChangeGroup={handleChangeGroup}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 5:
                return (
                    <StepSeven
                        handleChange={onChangeAnnounce}
                        values={announce}
                        handleChangeCheckedAnimaux={handleChangeCheckedAnimaux}
                        handleChangeCheckedEnfant={handleChangeCheckedEnfant}
                        handleChangeCheckedFetes={handleChangeCheckedFetes}
                        checkedAnimaux={checkedAnimaux}
                        checkedEnfant={checkedEnfant}
                        checkedFetes={checkedFetes}
                        checkin={checkin}
                        checkout={checkout}
                        handleValueChange={handleValueChange}
                        handleValueChangeOut={handleValueChangeOut}
                        searchTypeName={SearchTypeName}
                    />
                );
            case 6:
                return (
                    <StepEight
                        values={announce}
                        acceptConditions={acceptConditions}
                        handleChange={onChangeAnnounce}
                        handleAcceptConditions={handleAcceptConditions}
                        searchTypeName={SearchTypeName}
                    />
                );
            // never forget the default case, otherwise VS code would be mad!
            default:
            // do nothing
        }
    };

    const showErrorsMessages = () => {
        let allErrorMessages = "";
        errors.forEach((error) => {
            if (error === "EMPTY NAME COMPANY") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EPropertyErrorMessages.EmptyNameHotel}`);
            } else if (error === "EMPTY NAME") {
                allErrorMessages +=
                    "," + t(`label.error.${EPropertyErrorMessages.EmptyName}`);
            } else if (error === "EMPTY ROOM TYPE") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EPropertyErrorMessages.EmptyRoomType}`);
            } else if (error === "EMPTY REGULATIONS") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EPropertyErrorMessages.EmptyRegulations}`);
            } else if (error === "EMPTY GUEST") {
                allErrorMessages +=
                    "," + t(`label.error.${EPropertyErrorMessages.EmptyGuest}`);
            } else if (error === "EMPTY ROOM") {
                allErrorMessages +=
                    "," + t(`label.error.${EPropertyErrorMessages.EmptyRoom}`);
            } else if (error === "EMPTY BED") {
                allErrorMessages +=
                    "," + t(`label.error.${EPropertyErrorMessages.EmptyBed}`);
            } else if (error === "EMPTY BATHROOM") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EPropertyErrorMessages.EmptyBathroom}`);
            } else if (error === "INSUFFICIENT PICTURES") {
                allErrorMessages +=
                    "," +
                    t(
                        `label.error.${EPropertyErrorMessages.InsufficientPictures}`
                    );
            } else if (error === "EMPTY DESCRIPTION") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EAnnounceErrorMessages.EmptyDescription}`);
            } else if (error === "EMPTY PRICE") {
                allErrorMessages +=
                    "," + t(`label.error.${EAnnounceErrorMessages.EmptyPrice}`);
            } else if (error === "EMPTY PREFERRED METHOD") {
                allErrorMessages +=
                    "," +
                    t(
                        `label.error.${EAnnounceErrorMessages.EmptyPreferredMethod}`
                    );
            } else if (error === "EMPTY ORANGE ACCOUNT") {
                allErrorMessages +=
                    "," +
                    t(
                        `label.error.${EAnnounceErrorMessages.EmptyOrangeAccount}`
                    );
            } else if (error === "EMPTY MTN ACCOUNT") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EAnnounceErrorMessages.EmptyMTNAccount}`);
            } else if (error === "EMPTY EXPRESS UNION ACCOUNT") {
                allErrorMessages +=
                    "," +
                    t(
                        `label.error.${EAnnounceErrorMessages.EmptyExpressUnionAccount}`
                    );
            } else if (error === "NULL PENALTY") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EAnnounceErrorMessages.NullPenalty}`);
            } else if (error === "EMPTY CONTACT NAME") {
                allErrorMessages +=
                    "," +
                    t(`label.error.${EAnnounceErrorMessages.EmptyContactName}`);
            } else if (error === "EMPTY CONTACT PHONE") {
                allErrorMessages +=
                    "," +
                    t(
                        `label.error.${EAnnounceErrorMessages.EmptyContactPhone}`
                    );
            } else if (error === "EMPTY LOCATION DESCRIPTION") {
                allErrorMessages +=
                    "," +
                    t(
                        `label.error.${EAnnounceErrorMessages.EmptyLocationDescription}`
                    );
            }
        });
        setErrorMessages(
            allErrorMessages.substring(1, allErrorMessages.length)
        );
    };
    const isHotelValidate = (_id: string): boolean => {
        if (_id === "") {
            if (!errors.includes("EMPTY NAME COMPANY"))
                errors = [...errors, "EMPTY NAME COMPANY"];
        }

        return !Boolean(errors.length);
    };

    const TypeHotelErrorMessages = (
        values: PropertyInputs,
        type: IPropertyTypeInputs
    ): boolean => {
        if (values.name === "") {
            if (!errors.includes("EMPTY NAME"))
                errors = [...errors, "EMPTY NAME"];
        } else if (values.typeChambre === "") {
            if (!errors.includes("EMPTY ROOM TYPE"))
                errors = [...errors, "EMPTY ROOM TYPE"];
        } else if (values.reglement === "") {
            if (!errors.includes("EMPTY REGULATIONS"))
                errors = [...errors, "EMPTY REGULATIONS"];
        } else if (values.maximumGuests === 0) {
            if (!errors.includes("EMPTY GUEST"))
                errors = [...errors, "EMPTY GUEST"];
        } else if (values.rooms === "" || values.rooms === "0") {
            if (!errors.includes("EMPTY ROOM"))
                errors = [...errors, "EMPTY ROOM"];
        } else if (values.lit === 0) {
            if (!errors.includes("EMPTY BED"))
                errors = [...errors, "EMPTY BED"];
        } else if (values.bathrooms === 0) {
            if (!errors.includes("EMPTY BATHROOM"))
                errors = [...errors, "EMPTY BATHROOM"];
        }
        return !Boolean(errors.length);
    };

    const isPhotosValidate = (values: PropertyInputs): boolean => {
        if (newPhotos?.length < 5 && property.photos?.length < 5) {
            if (!errors.includes("INSUFFICIENT PICTURES"))
                errors = [...errors, "INSUFFICIENT PICTURES"];
        }
        return !Boolean(errors.length);
    };

    const isAnnounceValidate = (values: AnnounceInputs): boolean => {
        if (values.description === "") {
            if (!errors.includes("EMPTY DESCRIPTION"))
                errors = [...errors, "EMPTY DESCRIPTION"];
        } else if (values.price === 0) {
            if (!errors.includes("EMPTY PRICE"))
                errors = [...errors, "EMPTY PRICE"];
        }
        return !Boolean(errors.length);
    };

    const isAnnounceStepSix = (
        values: AnnounceInputs,
        property: PropertyInputs
    ): boolean => {
        if (
            property.address.country?.name === "Cameroon" &&
            values.favoritePaymentMethod === ""
        ) {
            if (!errors.includes("EMPTY PREFERRED METHOD"))
                errors = [...errors, "EMPTY PREFERRED METHOD"];
        } else if (
            property.address.country?.name === "Cameroon" &&
            values.favoritePaymentMethod !== ""
        ) {
            if (
                values.favoritePaymentMethod === EPaymentMethod.Orange &&
                values.account_orange === ""
            ) {
                if (!errors.includes("EMPTY ORANGE ACCOUNT"))
                    errors = [...errors, "EMPTY ORANGE ACCOUNT"];
            }
            if (
                values.favoritePaymentMethod === EPaymentMethod.MTN &&
                values.account_mtn === ""
            ) {
                if (!errors.includes("EMPTY MTN ACCOUNT"))
                    errors = [...errors, "EMPTY MTN ACCOUNT"];
            }
            if (
                values.favoritePaymentMethod === EPaymentMethod.ExpressUnion &&
                values.account_express_union === ""
            ) {
                if (!errors.includes("EMPTY EXPRESS UNION ACCOUNT"))
                    errors = [...errors, "EMPTY EXPRESS UNION ACCOUNT"];
            }
        } else if (values.penaltyDayFees === 0 && values.remboursable==="remboursable") {
            if (!errors.includes("NULL PENALTY"))
                errors = [...errors, "NULL PENALTY"];
        }
        return !Boolean(errors.length);
    };

    const isAnnounceStepEight = (values: AnnounceInputs): boolean => {
        // Clear errors array at the beginning
        errors = [];
    
        // Validate fields individually
        if (values.contactName === "") {
            if (!errors.includes("EMPTY CONTACT NAME")) {
                errors.push("EMPTY CONTACT NAME");
            }
        }
    
        if (values.contactPhone === "") {
            if (!errors.includes("EMPTY CONTACT PHONE")) {
                errors.push("EMPTY CONTACT PHONE");
            }
        }
    
        if (values.howToAccessDesc === "") {
            if (!errors.includes("EMPTY LOCATION DESCRIPTION")) {
                errors.push("EMPTY LOCATION DESCRIPTION");
            }
        }
    
        // Return false if there are any errors, true otherwise
        return errors.length === 0;
    };

    const handleSubmit = () => {
        if (isAnnounceStepEight(announce)) {
            setIsSaving(true);
            errors = [];
            setErrorMessages("");
            propertyService
                .updatePropertyById(
                    property._id ? property : { ...property, _id: draftedId! }
                )
                .then((response) => {
                    if (response.success === true) {
                        propertyService
                            .saveAnnounce(
                                {
                                    ...announce,
                                    _id: draftedAnnounceId!,
                                    state: EAnnounceStatus.Submitted,
                                    activeStep,
                                },
                                property._id || draftedId!
                            )
                            .then((response) => {
                                if (response.success) {
                                    history.push("/announces");
                                }
                                setIsSaving(false);
                            })
                            .catch((error) => {
                                setIsSaving(false);
                                console.log(
                                    "create property(annouce) component err",
                                    error
                                );
                                setLoading(false);
                            })
                            .catch((error) => {
                                setIsSaving(false);
                                showErrorsMessages();
                            });
                    }
                })
                .catch((error) => {
                    setIsSaving(false);
                    showErrorsMessages();
                });
        } else {
            showErrorsMessages();
        }
    };

    const handleArchive = (button: string) => {
        errors = [];
        setErrorMessages("");
        if (property.address) {
            if (property.address.city && typeof property.address.city === 'object') {
                const cityId = property.address.city?._id || null; // Extract _id
                (property.address.city as any) = cityId; // Type assertion to bypass the type error
            }
            if (property.address.country && typeof property.address.country === 'object') {
                const countryId = property.address.country?._id || null; // Extract _id
                (property.address.country as any) = countryId; // Type assertion to bypass the type error
            }
        }
        if (!params.id && !draftedId) {
            delete property.photos;
            propertyService
                .saveProperty({ ...property, owner: user._id })
                .then((response) => {
                    if (response.success === true) {
                        setDraftedId(response.property._id);
                        if (property.photos && property.photos.length) {
                            property.photos?.forEach(
                                (photo: any, index: number) => {
                                    let formData = new FormData();
                                    formData.append(`photo`, photo);
                                    propertyService
                                        .savePropertyPhotosById(
                                            response.property._id,
                                            formData
                                        )
                                        .then((response) => {
                                            if (response.success)
                                                propertyService
                                                    .getPropertyById(draftedId!)
                                                    .then((response) => {
                                                        if (response.success)
                                                            setProperty(
                                                                response.data
                                                            );
                                                    });
                                        })
                                        .finally(() => {
                                            setNewPhotos([]);
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                }
                            );
                        }
                        propertyService
                            .saveAnnounce(
                                {
                                    ...announce,
                                    state: EAnnounceStatus.Drafted,
                                    activeStep:
                                        button === Ebutton.Next
                                            ? activeStep + 1
                                            : activeStep,
                                },
                                response.property._id
                            )
                            .then((response) => {
                                if (response.success) {
                                    // setAnnounce(response.announce);
                                    setDraftedAnnounceId(response.announce._id);
                                    if (button === Ebutton.Archive)
                                        history.push("/announces");
                                }
                                setIsSaving(false);
                            })
                            .catch((error) => {
                                setIsSaving(false);
                                console.log(error);
                            });
                    }
                })
                .catch((error) => {
                    setIsSaving(false);
                    showErrorsMessages();
                });
        } else {
            let tabPhotos: any = [];
            property.photos?.forEach((pho: any) => {
                if (pho.filename !== undefined) {
                    tabPhotos.push(pho);
                }
            });
            propertyService
                .updatePropertyById(
                    property._id
                        ? property
                        : { ...property, _id: draftedId! }
                )
                .then((response) => {
                    if (response.success === true) {
                        propertyService
                            .saveAnnounce(
                                {
                                    ...announce,
                                    state: EAnnounceStatus.Drafted,
                                    _id: draftedAnnounceId!,
                                    activeStep:
                                        button === Ebutton.Next
                                            ? activeStep + 1
                                            : activeStep,
                                },
                                property._id || draftedId!
                            )
                            .then((response) => {
                                if (response.success) {
                                    // setAnnounce(response.announce);
                                }
                            })
                            .catch((error) => {
                                console.log(
                                    "edit property(annouce) component err",
                                    error
                                );
                                setLoading(false);
                            });
                        if (newPhotos && newPhotos.length && activeStep === 2) {
                            newPhotos.forEach((photo: any) => {
                                let formData = new FormData();
                                formData.append(`photo`, photo);
                                if (property._id || draftedId) {
                                    propertyService
                                        .savePropertyPhotosById(
                                            property._id ?? draftedId!,
                                            formData
                                        )
                                        .then((response) => {
                                            if (response.success) {
                                                propertyService
                                                    .getPropertyById(draftedId!)
                                                    .then((response) => {
                                                        if (response.success)
                                                            setProperty(
                                                                response.data
                                                            );
                                                    });
                                                if (button === Ebutton.Archive)
                                                    history.push("/announces");
                                            }
                                        })
                                        .finally(() => {
                                            setNewPhotos([]);
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                            if (button === Ebutton.Archive)
                                                history.push("/announces");
                                            setLoading(false);
                                        });
                                }
                            });
                        } else {
                            if (button === Ebutton.Archive)
                                history.push("/announces");
                        }
                    }
                })
                .catch((error) => {
                    console.log("update property", error);
                    setLoading(false);
                    showErrorsMessages();
                });
        }
    };

    const handleCancel = () => {
        history.push("/announces");
    };

    return (
        <div className={classes.properties}>
            <Grid container direction="column">
                <Grid item className={classes.propertiesHeader}>
                    <Typography
                        variant="h5"
                        gutterBottom
                        className={classes.propertiesTitle}
                    >
                        {activeStep === 5
                            ? t("annonce.title.creezVotreAnnonce")
                            : t("propriete.title.decrivezVotrePropriete")}
                    </Typography>
                    <Stepper
                        activeStep={activeStep}
                        className={classes.propertiesStepper}
                    >
                        {steps.map((label, index) => {
                            const stepProps: { completed?: boolean } = {};
                            const labelProps: { optional?: React.ReactNode } =
                                {};
                            if (isStepSkipped(index)) {
                                stepProps.completed = false;
                            }
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>
                                        {/* {label} */}
                                    </StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                </Grid>
                <Grid>
                    <MessageBrouillon />
                </Grid>
                <Grid
                    item
                    container
                    spacing={3}
                    justifyContent="center"
                    direction="row"
                >
                    {activeStep === 0 ? (
                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.propertiesCheck}
                        >
                            {loading ? (
                                <CircularProgress
                                    size={32}
                                    style={{ color: "#890608" }}
                                />
                            ) : (
                                <>
                                    <div className={classes.propertiesCheckbox}>
                                        {actualStepForm()}
                                        <div className={classes.showErrors}>
                                            {errorMessages && (
                                                <div className={classes.errors}>
                                                    <Typography>
                                                        <Error />
                                                        <br />
                                                        <span>
                                                            {errorMessages}
                                                        </span>
                                                    </Typography>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {activeStep < steps.length && (
                                        <div className={classes.propertiesBtn}>
                                            <Button
                                                // disabled={activeStep === 0}
                                                onClick={
                                                    activeStep === 0
                                                        ? handleCancel
                                                        : handleBack
                                                }
                                                className={
                                                    classes.ButtonPrevious
                                                }
                                            >
                                                {activeStep === 0
                                                    ? t(
                                                          "propriete.buttonCancel"
                                                      )
                                                    : t(
                                                          "propriete.buttonPrevious"
                                                      )}
                                            </Button>
                                            <Button
                                                onClick={
                                                    activeStep ===
                                                    steps.length - 1
                                                        ? handleSubmit
                                                        : handleNext
                                                }
                                                endIcon={
                                                    activeStep ===
                                                        steps.length - 1 &&
                                                    isSaving ? (
                                                        <Spin />
                                                    ) : null
                                                }
                                                className={classes.Button}
                                                disabled={
                                                    (activeStep ===
                                                        steps.length - 1 &&
                                                        isSaving) ||
                                                    (activeStep ===
                                                        steps.length - 1 &&
                                                        !acceptConditions)
                                                }
                                            >
                                                {activeStep === steps.length - 1
                                                    ? `${t(
                                                          "propriete.buttonValidate"
                                                      )}`
                                                    : `${t(
                                                          "propriete.buttonNext"
                                                      )}`}
                                            </Button>
                                        </div>
                                    )}
                                </>
                            )}
                        </Grid>
                    ) : (
                        <>
                            <Grid item lg={6} md={6} sm={12}>
                                <img
                                    src={announcePic}
                                    alt="Announce illustration"
                                />
                            </Grid>
                            <Grid
                                item
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                                className={classes.propertiesCheck}
                            >
                                {loading ? (
                                    <CircularProgress
                                        size={32}
                                        style={{ color: "#890608" }}
                                    />
                                ) : (
                                    <>
                                        <div
                                            className={
                                                classes.propertiesCheckbox
                                            }
                                        >
                                            {actualStepForm()}
                                            <div className={classes.showErrors}>
                                                {errorMessages && (
                                                    <div
                                                        className={
                                                            classes.errors
                                                        }
                                                    >
                                                        <Typography>
                                                            <Error />
                                                            <br />
                                                            <span>
                                                                {errorMessages}
                                                            </span>
                                                        </Typography>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {activeStep < steps.length && (
                                            <div
                                                className={
                                                    classes.propertiesBtn
                                                }
                                            >
                                                <Button
                                                    // disabled={activeStep === 0}
                                                    onClick={
                                                        activeStep === 0
                                                            ? handleCancel
                                                            : handleBack
                                                    }
                                                    className={
                                                        classes.ButtonPrevious
                                                    }
                                                >
                                                    {activeStep === 0
                                                        ? t(
                                                              "propriete.buttonCancel"
                                                          )
                                                        : t(
                                                              "propriete.buttonPrevious"
                                                          )}
                                                </Button>
                                                <Button
                                                    className={classes.Button}
                                                    onClick={() =>
                                                        handleArchive(
                                                            Ebutton.Archive
                                                        )
                                                    }
                                                >
                                                    {t(
                                                        "propriete.buttonArchiver"
                                                    )}
                                                </Button>
                                                <Button
                                                    onClick={
                                                        activeStep ===
                                                        steps.length - 1
                                                            ? handleSubmit
                                                            : handleNext
                                                    }
                                                    endIcon={
                                                        activeStep ===
                                                            steps.length - 1 &&
                                                        isSaving ? (
                                                            <Spin />
                                                        ) : null
                                                    }
                                                    className={classes.Button}
                                                    disabled={
                                                        (activeStep ===
                                                            steps.length - 1 &&
                                                            isSaving) ||
                                                        (activeStep ===
                                                            steps.length - 1 &&
                                                            !acceptConditions)
                                                    }
                                                >
                                                    {activeStep ===
                                                    steps.length - 1
                                                        ? `${t(
                                                              "propriete.buttonValidate"
                                                          )}`
                                                        : `${t(
                                                              "propriete.buttonNext"
                                                          )}`}
                                                </Button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>
        </div>
    );
}
